/* OMNÉA Warenkorb-Schublade (17.10.2026) – gehört zu sections/omnea-schublade.liquid.
   Öffnet sich nach dem Hinzufügen (Produktseite über Dawns product-form.js, Schnellkauf über omnea-okl-stil.liquid,
   Set-Baukasten, „Passt gut zusammen“ in omnea-produkt-extras.liquid) und beim Tippen auf das Korb-Symbol im Kopf,
   Menge ±, Entfernen und der Vorschlag laufen über cart/change.js bzw. cart/add.js. Danach wird der Abschnitt
   'omnea-schublade' frisch eingesetzt, die Zahl am Korb im Kopf aktualisiert und cartUpdate gemeldet. */
(function () {
  if (customElements.get('omnea-schublade')) return;
  var SEKTION = 'omnea-schublade';

  function json(url, daten) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(daten),
    }).then(function (r) { return r.json(); });
  }
  function routen(name, notfall) {
    return (window.routes && window.routes[name]) || notfall;
  }
  function melden(daten, varianteId) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: SEKTION, productVariantId: varianteId, cartData: daten });
    }
  }

  class OmneaSchublade extends HTMLElement {
    connectedCallback() {
      this.dlg = this.querySelector('dialog');
      if (!this.dlg) return;
      this.addEventListener('click', this.klick.bind(this));
      this.dlg.addEventListener('cancel', (e) => { e.preventDefault(); this.schliessen(); });
      window.addEventListener('pageshow', (e) => { if (e.persisted) this.neuLaden(); });
      window.omneaSchublade = this;
      this.korbSymbol();
    }

    /* Korb-Symbol im Kopf öffnet die Schublade statt /cart. Ohne JS, mit Strg/⌘/⇧-Klick oder Mittelklick bleibt es der Link auf /cart. */
    korbSymbol() {
      var a = document.getElementById('cart-icon-bubble');
      if (a) { a.setAttribute('aria-haspopup', 'dialog'); a.setAttribute('aria-controls', this.dlg.id); }
      document.addEventListener('click', (e) => {
        var link = e.target.closest && e.target.closest('#cart-icon-bubble');
        if (!link || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        this.setActiveElement(link);
        this.oeffnen();
      });
    }

    /* Schnittstelle, die Dawns product-form.js erwartet (wie cart-drawer / cart-notification) */
    getSectionsToRender() { return [{ id: SEKTION }]; }
    setActiveElement(el) { this.aktiv = el; }
    renderContents(antwort) { this.zeigen(antwort); }

    /* Antwort von cart/add (mit sections) einsetzen und öffnen */
    zeigen(antwort) {
      var html = antwort && antwort.sections && antwort.sections[SEKTION];
      if (html) this.einsetzen(html); else this.neuLaden();
      this.oeffnen();
    }

    neuLaden() {
      var basis = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return fetch(basis + '?sections=' + SEKTION)
        .then(function (r) { return r.json(); })
        .then((d) => { if (d && d[SEKTION]) this.einsetzen(d[SEKTION]); })
        .catch(function () {});
    }

    einsetzen(html) {
      var neu = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-osch-inhalt]');
      var alt = this.querySelector('[data-osch-inhalt]');
      if (!neu || !alt) return;
      var fokus = document.activeElement && alt.contains(document.activeElement) ? document.activeElement : null;
      var rolle = fokus && fokus.getAttribute('data-osch-rolle');
      var zeile = fokus && fokus.closest('[data-key]');
      var mitte = alt.querySelector('.osch__mitte');
      var pos = mitte ? mitte.scrollTop : 0;
      alt.replaceWith(neu);
      var m2 = neu.querySelector('.osch__mitte');
      if (m2) m2.scrollTop = pos;
      this.zaehler(parseInt(neu.getAttribute('data-anzahl'), 10) || 0);
      if (fokus && this.dlg.open) {
        var ziel = null;
        if (rolle && zeile) ziel = neu.querySelector('[data-key="' + zeile.getAttribute('data-key') + '"] [data-osch-rolle="' + rolle + '"]');
        else if (rolle) ziel = neu.querySelector('[data-osch-rolle="' + rolle + '"]');
        if (!ziel || ziel.disabled) ziel = neu.querySelector('.osch__titel');
        if (ziel) ziel.focus({ preventScroll: true });
      }
    }

    /* Zahl am Korb im Kopf (omnea-Kopf: a#cart-icon-bubble > span.omnea-cart__count) */
    zaehler(n) {
      var a = document.getElementById('cart-icon-bubble');
      if (!a) return;
      var z = a.querySelector('.omnea-cart__count');
      if (n > 0) {
        if (!z) { z = document.createElement('span'); z.className = 'omnea-cart__count'; a.appendChild(z); }
        z.textContent = n;
      } else if (z) {
        z.remove();
      }
      a.setAttribute('aria-label', 'Warenkorb' + (n > 0 ? ', ' + n + ' Artikel' : ''));
    }

    oeffnen() {
      if (this.dlg.open) return;
      var h = document.documentElement;
      h.style.setProperty('--osch-sb', Math.max(0, window.innerWidth - h.clientWidth) + 'px');
      h.classList.add('osch-offen');
      this.dlg.showModal();
      void this.dlg.offsetWidth;
      this.dlg.classList.add('is-offen');
      var titel = this.querySelector('.osch__titel');
      if (titel) titel.focus({ preventScroll: true });
    }

    schliessen() {
      if (!this.dlg.open || this.zu) return;
      this.zu = true;
      this.dlg.classList.remove('is-offen');
      var fertig = () => {
        this.dlg.close();
        var h = document.documentElement;
        h.classList.remove('osch-offen');
        h.style.removeProperty('--osch-sb');
        this.zu = false;
        if (this.aktiv && document.contains(this.aktiv)) this.aktiv.focus({ preventScroll: true });
        this.aktiv = null;
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) fertig();
      else setTimeout(fertig, 320);
    }

    klick(e) {
      if (e.target.closest('[data-osch-zu]')) { e.preventDefault(); this.schliessen(); return; }
      var m = e.target.closest('[data-osch-menge]');
      if (m && !m.disabled) { this.menge(m.closest('[data-key]'), parseInt(m.getAttribute('data-osch-menge'), 10)); return; }
      var add = e.target.closest('[data-osch-add]');
      if (add && !add.disabled) this.dazu(add);
    }

    fehler(box, text) {
      var f = box && box.querySelector('.osch__fehler');
      if (!f) return;
      f.textContent = text || 'Das hat nicht geklappt. Bitte versuch es noch einmal.';
      f.hidden = false;
    }

    menge(zeile, anzahl) {
      if (!zeile || this.laeuft) return;
      this.laeuft = true;
      zeile.classList.add('is-laden');
      json(routen('cart_change_url', '/cart/change') + '.js', {
        id: zeile.getAttribute('data-key'),
        quantity: Math.max(0, anzahl),
        sections: SEKTION,
        sections_url: window.location.pathname,
      })
        .then((d) => {
          if (d.status) {
            // z. B. 422 „nur 10 verfügbar“: Shopify setzt die Menge trotzdem auf den Bestand → frisch laden, dann Hinweis zeigen
            var key = zeile.getAttribute('data-key');
            var text = d.description || d.message;
            return this.neuLaden().then(() => {
              this.fehler(this.querySelector('[data-key="' + key + '"]') || zeile, text);
              zeile.classList.remove('is-laden');
            });
          }
          this.einsetzen(d.sections && d.sections[SEKTION]);
          melden(d);
        })
        .catch(() => { zeile.classList.remove('is-laden'); this.fehler(zeile); })
        .finally(() => { this.laeuft = false; });
    }

    dazu(knopf) {
      if (this.laeuft) return;
      this.laeuft = true;
      knopf.classList.add('is-laden');
      var id = parseInt(knopf.getAttribute('data-osch-add'), 10);
      json(routen('cart_add_url', '/cart/add') + '.js', {
        items: [{ id: id, quantity: 1 }],
        sections: SEKTION,
        sections_url: window.location.pathname,
      })
        .then((d) => {
          if (d.status) {
            knopf.classList.remove('is-laden');
            if (d.status == 422) knopf.disabled = true;
            this.fehler(knopf.closest('.osch__vinfo'), d.description || d.message);
            return;
          }
          this.einsetzen(d.sections && d.sections[SEKTION]);
          melden(d, id);
        })
        .catch(() => { knopf.classList.remove('is-laden'); this.fehler(knopf.closest('.osch__vinfo')); })
        .finally(() => { this.laeuft = false; });
    }
  }

  customElements.define('omnea-schublade', OmneaSchublade);
})();
